// Consenso alla comunicazione dei dati al partner di ristrutturazione
// (newarc-platform#3234). Casella OBBLIGATORIA nei tre flussi in cui un cliente
// di immaginacasa.com passa alla ristrutturazione: preventivo (anche da
// loggato), videocall, "Fatti ricontattare". Si aggiunge alla spunta privacy
// (privacyConsent.js), non la sostituisce.
//
// TESTO PROVVISORIO: da validare con il consulente privacy quando la società
// Immaginacasa sarà costituita. Il testo vive SOLO in shareConsentParts qui
// sotto (casella e documento salvato lo leggono da lì) e la versione viaggia
// con il consenso: chi cambia il testo alza SHARE_CONSENT_VERSION.
//
// Il destinatario è un parametro (RENOVATION_PARTNER): domani può essere
// un'altra ditta senza riscrivere i moduli. `recipient` è la sua chiave
// azienda (newarc-cloud-functions, companyLinks/core.ts: RENOVATION_PARTNER).
//
// Forma salvata (newarc-cloud-functions companyLinks/core.ts parseShareConsent
// la copia in users.companyLinks.<recipient>.consent; regola Firestore
// validShareConsent di newarc-platform), esattamente queste sei chiavi:
//   shareConsent: { accepted, acceptedAt, text, version, policyUrl, recipient }
import { PRIVACY_POLICY_URL } from "./privacyConsent.js";

export const RENOVATION_PARTNER = Object.freeze({ key: "newarc", name: "Newarc S.r.l." });
export const SHARE_CONSENT_VERSION = 1;
export const SHARE_CONSENT_POLICY_URL = PRIVACY_POLICY_URL;

const SHARE_CONSENT_KEYS = ["accepted", "acceptedAt", "policyUrl", "recipient", "text", "version"];

export function shareConsentParts(partnerName = RENOVATION_PARTNER.name) {
  return Object.freeze({
    before:
      `Acconsento alla comunicazione dei miei dati e della mia richiesta a ${partnerName}, ` +
      "partner di ristrutturazione di Immaginacasa, perché mi contatti per un preventivo, " +
      "una consulenza e l'eventuale progetto di ristrutturazione, come descritto nell'",
    link: "informativa sulla privacy",
    after: ".",
  });
}

export function shareConsentText(partnerName = RENOVATION_PARTNER.name) {
  const { before, link, after } = shareConsentParts(partnerName);
  return before + link + after;
}

// Oggetto da inviare con la richiesta, al momento dell'invio.
export function buildShareConsent(now = Date.now(), partner = RENOVATION_PARTNER) {
  return {
    accepted: true,
    acceptedAt: now,
    text: shareConsentText(partner.name),
    version: SHARE_CONSENT_VERSION,
    policyUrl: SHARE_CONSENT_POLICY_URL,
    recipient: partner.key,
  };
}

// Guardia dei servizi: la stessa forma esatta che server e regole accettano
// (sei chiavi, nessuna in più).
export function isShareConsent(c) {
  return (
    !!c &&
    typeof c === "object" &&
    Object.keys(c).sort().join(",") === SHARE_CONSENT_KEYS.join(",") &&
    c.accepted === true &&
    Number.isInteger(c.acceptedAt) &&
    typeof c.text === "string" &&
    c.text !== "" &&
    typeof c.policyUrl === "string" &&
    c.policyUrl !== "" &&
    Number.isInteger(c.version) &&
    typeof c.recipient === "string" &&
    /^[a-z][a-z0-9-]{1,39}$/.test(c.recipient)
  );
}

// Solo su una pagina Immaginacasa il cliente passa a un'altra azienda: su una
// pagina Newarc (compra.newarc.it, arrivo da newarc.it) è già cliente Newarc.
export function needsShareConsent(pageBrand) {
  return pageBrand === "immaginacasa";
}
